<template>
    <div>
        <div class="footer"
             id="step-three">
            <div>
                <a href="javascript:;"
                   @click="fnWndMultiPhone(true)">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         xmlns:xlink="http://www.w3.org/1999/xlink"
                         width="12px"
                         height="16px"
                         style="position:relative;margin-right:4px;top:2px;">
                        <path fill-rule="evenodd"
                              fill="rgb(170, 170, 170)"
                              d="M10.000,16.000 L2.000,16.000 C0.895,16.000 -0.000,15.105 -0.000,14.000 L-0.000,2.000 C-0.000,0.895 0.895,-0.000 2.000,-0.000 L10.000,-0.000 C11.105,-0.000 12.000,0.895 12.000,2.000 L12.000,14.000 C12.000,15.105 11.105,16.000 10.000,16.000 ZM10.000,4.000 C10.000,2.895 9.105,2.000 8.000,2.000 L4.000,2.000 C2.895,2.000 2.000,2.895 2.000,4.000 L2.000,12.000 C2.000,13.105 2.895,14.000 4.000,14.000 L8.000,14.000 C9.105,14.000 10.000,13.105 10.000,12.000 L10.000,4.000 ZM7.000,5.000 L5.000,5.000 C4.448,5.000 4.000,4.552 4.000,4.000 C4.000,3.448 4.448,3.000 5.000,3.000 L7.000,3.000 C7.552,3.000 8.000,3.448 8.000,4.000 C8.000,4.552 7.552,5.000 7.000,5.000 ZM6.000,11.000 C6.552,11.000 7.000,11.448 7.000,12.000 C7.000,12.552 6.552,13.000 6.000,13.000 C5.448,13.000 5.000,12.552 5.000,12.000 C5.000,11.448 5.448,11.000 6.000,11.000 Z" />
                    </svg>
                    <span>绑定手机</span>
                </a>
                <a href="javascript:;"
                   @click="fnRefreshData">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         xmlns:xlink="http://www.w3.org/1999/xlink"
                         width="17px"
                         height="16px"
                         style="position:relative;margin-right:4px;top:2px;">
                        <path fill-rule="evenodd"
                              fill="rgb(170, 170, 170)"
                              d="M16.910,7.392 C16.760,7.757 16.405,8.015 15.988,8.015 L9.994,8.015 C9.442,8.015 8.995,7.564 8.995,7.008 C8.995,6.452 9.442,6.001 9.994,6.001 L13.626,6.001 C13.577,5.849 13.542,5.694 13.475,5.545 C12.119,2.521 8.569,1.169 5.545,2.525 C2.521,3.881 1.169,7.431 2.525,10.455 C3.881,13.479 7.431,14.831 10.455,13.475 C11.825,12.860 12.829,11.784 13.416,10.521 C13.766,10.281 14.522,9.696 15.000,10.000 C15.371,10.236 15.178,11.017 15.280,11.296 C14.504,13.013 13.128,14.468 11.273,15.300 C7.242,17.107 2.508,15.305 0.700,11.273 C-1.107,7.242 0.695,2.508 4.727,0.700 C8.545,-1.012 12.989,0.518 14.985,4.110 L14.985,0.994 C14.985,0.442 15.436,-0.005 15.992,-0.005 C16.548,-0.005 16.999,0.442 16.999,0.994 L16.999,6.988 C16.999,7.132 16.966,7.268 16.910,7.392 ZM14.902,6.001 L14.985,6.001 L14.985,5.964 L14.902,6.001 Z" />
                    </svg>
                    <span v-text="btnRefreshDataTxt"></span>
                </a>
                <a href="javascript:;"
                   @click="fnWndMultiAccount(true)">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         xmlns:xlink="http://www.w3.org/1999/xlink"
                         width="21px"
                         height="23px"
                         style="position:relative;top:8px;">
                        <path fill-rule="evenodd"
                              fill="rgb(170, 170, 170)"
                              d="M7.000,11.000 C4.239,11.000 2.000,13.239 2.000,16.000 L-0.000,16.000 C-0.000,13.298 1.533,10.958 3.774,9.791 C2.698,8.874 2.000,7.525 2.000,6.000 C2.000,3.239 4.239,1.000 7.000,1.000 C9.761,1.000 12.000,3.239 12.000,6.000 C12.000,7.525 11.302,8.874 10.225,9.791 C12.467,10.958 14.000,13.298 14.000,16.000 L12.000,16.000 C12.000,13.239 9.761,11.000 7.000,11.000 ZM7.000,3.000 C5.343,3.000 4.000,4.343 4.000,6.000 C4.000,7.657 5.343,9.000 7.000,9.000 C8.657,9.000 10.000,7.657 10.000,6.000 C10.000,4.343 8.657,3.000 7.000,3.000 Z" />
                        <path fill-rule="evenodd"
                              fill="rgb(170, 170, 170)"
                              d="M21.000,15.000 L19.000,15.000 C19.000,12.239 16.761,10.000 14.000,10.000 C13.867,10.000 13.740,10.018 13.611,10.031 C13.481,9.952 13.346,9.884 13.211,9.814 C13.813,9.309 14.300,8.673 14.610,7.937 C15.974,7.656 17.000,6.448 17.000,5.000 C17.000,3.343 15.657,2.000 14.000,2.000 C13.700,2.000 13.415,2.058 13.142,2.140 C12.507,1.622 11.754,1.248 10.916,1.092 C11.767,0.419 12.830,-0.000 14.000,-0.000 C16.761,-0.000 19.000,2.239 19.000,5.000 C19.000,6.536 18.293,7.893 17.203,8.810 C19.449,9.975 21.000,12.295 21.000,15.000 Z" />
                    </svg>
                    小号
                </a>
                <a href="javascript:;"
                   @click="fnWndMultiClock(true)">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         xmlns:xlink="http://www.w3.org/1999/xlink"
                         width="15px"
                         height="16px"
                         style="position:relative;top:2px;">
                        <path fill-rule="evenodd"
                              fill="rgb(170, 170, 170)"
                              d="M12.527,13.250 L13.763,14.486 C14.107,14.830 14.107,15.388 13.763,15.732 C13.419,16.076 12.861,16.076 12.517,15.732 L11.284,14.499 C10.097,15.425 8.623,16.000 7.000,16.000 C5.385,16.000 3.917,15.431 2.733,14.513 L1.514,15.732 C1.170,16.076 0.612,16.076 0.268,15.732 C-0.076,15.388 -0.076,14.830 0.268,14.486 L1.487,13.267 C0.569,12.083 -0.000,10.615 -0.000,9.000 C-0.000,7.401 0.557,5.945 1.459,4.767 C0.600,4.371 -0.000,3.508 -0.000,2.500 C-0.000,1.119 1.119,-0.000 2.500,-0.000 C3.823,-0.000 4.894,1.030 4.983,2.330 C5.626,2.136 6.294,2.000 7.000,2.000 C7.706,2.000 8.374,2.136 9.017,2.330 C9.106,1.030 10.177,-0.000 11.500,-0.000 C12.881,-0.000 14.000,1.119 14.000,2.500 C14.000,3.508 13.400,4.371 12.541,4.767 C13.443,5.945 14.000,7.401 14.000,9.000 C14.000,10.607 13.437,12.069 12.527,13.250 ZM2.500,2.000 C2.224,2.000 2.000,2.224 2.000,2.500 C2.000,2.776 2.224,3.000 2.500,3.000 C2.776,3.000 3.000,2.776 3.000,2.500 C3.000,2.224 2.776,2.000 2.500,2.000 ZM11.500,2.000 C11.224,2.000 11.000,2.224 11.000,2.500 C11.000,2.776 11.224,3.000 11.500,3.000 C11.776,3.000 12.000,2.776 12.000,2.500 C12.000,2.224 11.776,2.000 11.500,2.000 ZM7.000,4.000 C4.238,4.000 2.000,6.239 2.000,9.000 C2.000,11.761 4.238,14.000 7.000,14.000 C9.761,14.000 12.000,11.761 12.000,9.000 C12.000,6.239 9.761,4.000 7.000,4.000 ZM9.000,10.000 L7.000,10.000 C6.448,10.000 6.000,9.552 6.000,9.000 L6.000,6.000 C6.000,5.448 6.448,5.000 7.000,5.000 C7.552,5.000 8.000,5.448 8.000,6.000 L8.000,8.000 L9.000,8.000 C9.552,8.000 10.000,8.448 10.000,9.000 C10.000,9.552 9.552,10.000 9.000,10.000 Z" />
                    </svg>
                    闹钟
                </a>
                <a href="javascript:;"
                   @click="fnWndMultiShutdown(true)">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         xmlns:xlink="http://www.w3.org/1999/xlink"
                         width="14px"
                         height="15px"
                         style="position:relative;top:2px;">
                        <path fill-rule="evenodd"
                              fill="rgb(170, 170, 170)"
                              d="M7.000,15.000 C3.134,15.000 -0.000,11.866 -0.000,8.000 C-0.000,4.834 2.115,2.190 5.000,1.325 L5.000,3.422 C3.236,4.194 2.000,5.951 2.000,8.000 C2.000,10.761 4.239,13.000 7.000,13.000 C9.761,13.000 12.000,10.761 12.000,8.000 C12.000,5.951 10.764,4.194 9.000,3.422 L9.000,1.325 C11.884,2.190 14.000,4.834 14.000,8.000 C14.000,11.866 10.866,15.000 7.000,15.000 ZM7.000,8.000 C6.448,8.000 6.000,7.552 6.000,7.000 L6.000,1.000 C6.000,0.448 6.448,-0.000 7.000,-0.000 C7.552,-0.000 8.000,0.448 8.000,1.000 L8.000,7.000 C8.000,7.552 7.552,8.000 7.000,8.000 Z" />
                    </svg>
                    定时关机
                </a>
            </div>
            <span class="version">
                当前版本：
                <span v-text="clientVersion"></span>
            </span>
        </div>
        <!--小号为空-->
        <modal-slot :data="wndMultiAccountData"
                    @fnBtnClick="fnBtnClick"
                    v-if="wndMultiAccount">
            <div class="multiAccountWraper">
                <div class="item item-1">你还没有添加小号哦！</div>
                <div class="item item-2">您可以通过添加小号来辅助打怪、升级等</div>
                <div class="item item-3">
                    <a href="javascript:;"
                       class="btnNml"
                       @click="fnBtnClick('wndMultiAccountAdd')">添加小号</a>
                </div>
                <!-- <div class="item item-4">
          还没有小号？
          <a href="javascript:;" class="colorfd9d2b">前往注册>></a>
        </div>-->
            </div>
        </modal-slot>
        <!-- 添加小号 -->
        <modal-slot :data="wndMultiAccountAddData"
                    @fnBtnClick="fnBtnClick"
                    v-if="wndMultiAccountAdd">
            <div class="wndMultiAccountAddWraper">
                <div class="item item-1">
                    <div class="label">小号账号：</div>
                    <div class="group">
                        <input type="text"
                               class="inputAccount"
                               placeholder="请填写小号账号"
                               spellcheck="false"
                               v-model="formMultiAccount.passport"
                               maxlength="32" />
                    </div>
                </div>
                <div class="item item-2">
                    <div class="label">小号密码：</div>
                    <div class="group">
                        <input type="password"
                               class="inputPassword"
                               placeholder="请填写密码"
                               maxlength="16"
                               v-model="formMultiAccount.password" />
                    </div>
                </div>
                <div class="item item-3">
                    <div class="label">游戏区服：</div>
                    <div class="group">
                        <div class="select">
                            <input type="text"
                                   class="inputSelect"
                                   placeholder="请选择游戏"
                                   v-model="formMultiAccount.game_name" />
                            <div class="options">
                                <div class="option"
                                     v-for="item in multiGameList"
                                     :key="item.game_code">
                                    <label :for="'game' + item.game_code">
                                        <input type="radio"
                                               name="allGame"
                                               :value="item.game_name"
                                               v-model="formMultiAccount.game_name"
                                               @change="fnMultiInputChange('allGame', item)"
                                               :id="'game' + item.game_code" />
                                        <span>{{item.game_name}}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="select">
                            <input type="text"
                                   class="inputSelect"
                                   placeholder="请选择区服"
                                   v-model="formMultiAccount.server_name" />
                            <div class="options">
                                <div class="option"
                                     v-for="item in multiGameServerList"
                                     :key="item.server_id">
                                    <label :for="'server' + item.server_id">
                                        <input type="radio"
                                               name="allServer"
                                               :value="item.server_name"
                                               v-model="formMultiAccount.server_name"
                                               @change="fnMultiInputChange('allServer', item)"
                                               :id="'server' + item.server_id" />
                                        <span>{{item.server_name}}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item item-4">
                    <div class="label">备注：</div>
                    <div class="group">
                        <input type="text"
                               class="inputRemarks"
                               placeholder="请填写备注信息（6个字以内）"
                               maxlength="6"
                               spellcheck="false"
                               v-model="formMultiAccount.remark" />
                    </div>
                </div>
                <div class="item item-5">
                    <div class="label">验证码：</div>
                    <div class="group">
                        <input type="text"
                               class="inputCode"
                               placeholder="请填写验证码"
                               spellcheck="false"
                               v-model="formMultiAccount.verifyCode"
                               maxlength="5" />
                        <a href="javascript:;"
                           @click="fnGetMultiVerifyCode"
                           class="btnChangeVerifyCode">
                            <img :src="formMultiAccountverifyCodeImg"
                                 alt="点击切换验证码" />
                        </a>
                    </div>
                </div>
                <div class="item item-6">
                    <a href="javascript:;"
                       class="btnNml"
                       @click="fnMultiAccountAdd"
                       v-text="btnMultiAccountAddTxt"></a>
                </div>
            </div>
        </modal-slot>
        <!-- 小号管理 -->
        <modal-slot :data="wndMultiAccountManageData"
                    @fnBtnClick="fnBtnClick"
                    v-if="wndMultiAccountManage">
            <svg xmlns="http://www.w3.org/2000/svg"
                 style="display:none;">
                <path id="iconEdit"
                      fill-rule="evenodd"
                      fill="rgb(136, 136, 136)"
                      d="M19.714,4.718 L10.762,13.695 C10.545,13.913 10.254,14.002 9.969,13.982 C9.950,13.983 9.933,13.992 9.914,13.992 L7.065,13.992 C7.062,13.992 7.060,13.990 7.056,13.990 C7.037,13.992 7.020,14.003 7.000,14.003 C6.783,14.003 6.593,13.911 6.430,13.781 C6.167,13.600 5.986,13.325 5.986,12.999 C5.986,12.954 6.007,12.916 6.014,12.872 L6.014,10.083 C6.014,10.064 6.023,10.047 6.024,10.027 C6.008,9.746 6.097,9.461 6.312,9.246 L15.265,0.294 C15.374,0.184 15.504,0.111 15.640,0.062 C16.017,-0.093 16.466,-0.019 16.772,0.286 L19.710,3.225 C19.917,3.432 20.015,3.705 20.011,3.976 C20.015,4.244 19.918,4.513 19.714,4.718 ZM15.998,2.452 L7.986,10.463 L7.986,12.007 L9.553,12.007 L17.542,3.996 L15.998,2.452 ZM2.000,6.000 L2.000,16.000 C2.000,17.104 2.895,18.000 4.000,18.000 L14.000,18.000 C15.105,18.000 16.000,17.104 16.000,16.000 L16.000,10.000 L18.000,10.000 L18.000,18.000 C18.000,19.104 17.104,20.000 16.000,20.000 L2.000,20.000 C0.895,20.000 -0.000,19.104 -0.000,18.000 L-0.000,4.000 C-0.000,2.895 0.895,2.000 2.000,2.000 L10.000,2.000 L10.000,4.000 L4.000,4.000 C2.895,4.000 2.000,4.895 2.000,6.000 Z" />
                <path id="iconDel"
                      fill-rule="evenodd"
                      fill="rgb(136, 136, 136)"
                      d="M17.000,6.000 L16.000,6.000 L16.000,7.999 L16.000,16.000 C16.000,18.209 14.209,20.000 12.000,20.000 L6.000,20.000 C3.791,20.000 2.000,18.209 2.000,16.000 L2.000,7.999 L2.000,6.000 L1.000,6.000 C0.448,6.000 -0.000,5.552 -0.000,5.000 C-0.000,4.447 0.448,4.000 1.000,4.000 L2.000,4.000 L2.000,3.999 L5.000,3.999 C5.000,1.790 6.791,-0.000 9.000,-0.000 C11.209,-0.000 13.000,1.790 13.000,3.999 L16.000,3.999 L16.000,4.000 L17.000,4.000 C17.552,4.000 18.000,4.447 18.000,5.000 C18.000,5.552 17.552,6.000 17.000,6.000 ZM9.000,2.000 C7.895,2.000 7.000,2.895 7.000,3.999 L11.000,3.999 C11.000,2.895 10.105,2.000 9.000,2.000 ZM14.000,6.000 L4.000,6.000 L4.000,14.000 C4.000,16.209 5.791,18.000 8.000,18.000 L10.000,18.000 C12.209,18.000 14.000,16.209 14.000,14.000 L14.000,6.000 ZM12.000,15.000 C11.448,15.000 11.000,14.552 11.000,14.000 L11.000,9.000 C11.000,8.447 11.448,8.000 12.000,8.000 C12.552,8.000 13.000,8.447 13.000,9.000 L13.000,14.000 C13.000,14.552 12.552,15.000 12.000,15.000 ZM9.000,15.000 C8.448,15.000 8.000,14.552 8.000,14.000 L8.000,9.000 C8.000,8.447 8.448,8.000 9.000,8.000 C9.552,8.000 10.000,8.447 10.000,9.000 L10.000,14.000 C10.000,14.552 9.552,15.000 9.000,15.000 ZM6.000,15.000 C5.448,15.000 5.000,14.552 5.000,14.000 L5.000,9.000 C5.000,8.447 5.448,8.000 6.000,8.000 C6.552,8.000 7.000,8.447 7.000,9.000 L7.000,14.000 C7.000,14.552 6.552,15.000 6.000,15.000 Z" />
            </svg>
            <div class="wndMultiAccountManageWraper">
                <div class="row row-0">
                    <div class="col col-1">游戏区服</div>
                    <div class="col col-2">小号（备注）</div>
                    <div class="col col-3">&nbsp;</div>
                    <div class="col col-4">操作</div>
                </div>
                <div class="inner">
                    <div class="row row-1"
                         v-for="(item, index) in wndMultiAccountListData"
                         :key="item.server_id">
                        <div class="col col-1">{{item.game_name}}{{item.server_name ? ('(' + item.server_name + ')') : ''}}</div>
                        <div class="col col-2">{{item.passport}}{{item.remark ? ('(' + item.remark + ')') : ''}}</div>
                        <div class="col col-3">
                            <a href="javascript:;"
                               class="btnBorder"
                               @click="fnPlayGame({
            url: item.play_url,
            gameType: item.game_type,
            gameName: item.game_name,
            gameCode: item.game_code,
            serverName: item.server_name,
            serverId: item.server_id,
            coreType: item.core_type,
            idx: index + 1,
            uid: item.uid,
            passport: item.passport
          })">开始游戏</a>
                        </div>
                        <div class="col col-4">
                            <div class="group">
                                <a href="javascript:;"
                                   class="btnEditAccount"
                                   @click="fnChangeMultiAccount(0, item.id, index)">
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                         xmlns:xlink="http://www.w3.org/1999/xlink"
                                         width="21px"
                                         height="20px">
                                        <use xlink:href="#iconEdit" />
                                    </svg>
                                </a>
                                <a href="javascript:;"
                                   class="btnDelAccount"
                                   @click="fnChangeMultiAccount(1, item.id, index)">
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                         xmlns:xlink="http://www.w3.org/1999/xlink"
                                         width="18px"
                                         height="20px">
                                        <use xlink:href="#iconDel" />
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btnMultiAccountAddWraper">
                    <a href="javascript:;"
                       class="btnNml btnMultiAccountAdd"
                       @click="fnAddMultiAccount">添加小号</a>
                </div>
            </div>
        </modal-slot>
        <!--闹钟设置-->
        <modal-slot :data="wndMultiClockAddData"
                    v-if="wndMultiClockAdd"
                    @fnBtnClick="fnBtnClick">
            <clock-setting @fnBtnClick="fnBtnClick"></clock-setting>
        </modal-slot>
        <!-- 关机设置 -->
        <modal-slot :data="wndMultiShutdownAddData"
                    v-if="wndMultiShutdownAdd"
                    @fnBtnClick="fnBtnClick">
            <shutdown-setting @fnBtnClick="fnBtnClick">
            </shutdown-setting>
        </modal-slot>
        <!-- 手机绑定 -->
        <modal-slot :data="wndMultiPhoneData"
                    v-if="wndMultiPhone"
                    @fnBtnClick="fnBtnClick">
            <bind-phone @fnBtnClick="fnBtnClick">
            </bind-phone>
        </modal-slot>
    </div>
</template>

<script>
import store from '../store'
import ModalSlot from '@/components/ModalSlot'
import ClockSetting from '@/components/ClockSetting'
import ShutdownSetting from '@/components/ShutdownSetting'
import BindPhone from '@/components/BindPhone'
export default {
    name: 'commFooter',
    data () {
        return {
            clientVersion: '',
            wndMultiAccountEmpty: true,
            wndMultiPhone: false,
            wndMultiPhoneData: {
                title: '绑定手机领取优惠券',
                style: {
                    width: '520px',
                    height: '300px',
                    marginLeft: '-260px',
                    marginTop: '-150px'
                },
                type: 'wndMultiPhone',
                class: 'wndMultiPhone'
            },
            wndMultiAccount: false,
            wndMultiAccountData: {
                title: '小号管理',
                style: {
                    width: '480px',
                    height: '330px',
                    marginLeft: '-240px',
                    marginTop: '-165px'
                },
                type: 'wndMultiAccount',
                class: 'wndMultiAccount'
            },
            wndMultiAccountAdd: false,
            wndMultiAccountAddData: {
                title: '小号管理',
                style: {
                    width: '480px',
                    height: '430px',
                    marginLeft: '-240px',
                    marginTop: '-215px'
                },
                type: 'wndMultiAccountAdd',
                class: 'wndMultiAccountAdd'
            },
            wndMultiAccountManage: false,
            wndMultiAccountManageData: {
                title: '小号管理',
                style: {
                    width: '770px',
                    height: '460px',
                    marginLeft: '-385px',
                    marginTop: '-230px'
                },
                type: 'wndMultiAccountManage',
                class: 'wndMultiAccountManage'
            },
            wndMultiAccountListData: [],
            formMultiAccount: {
                passport: '',
                password: '',
                game_name: '',
                game_code: '',
                server_name: '',
                server_id: '',
                remark: '',
                verifyCode: '',
                verifyCodeImg: ''
            },
            formMultiAccountverifyCodeImg: '',
            multiGameList: [],
            multiGameServerList: [],
            btnMultiAccountAddTxt: '添加小号',
            btnFastClick: false,
            multiAccountGameId: '',
            btnRefreshData: true,
            btnRefreshDataTxt: '刷新页面',
            wndMultiClockAdd: false,
            wndMultiClockAddData: {
                title: '闹钟设置',
                style: {
                    width: '480px',
                    height: '340px',
                    marginLeft: '-240px',
                    marginTop: '-170px'
                },
                type: 'wndMultiClockAdd',
                class: 'wndMultiClockAdd'
            },
            wndMultiShutdownAdd: false,
            wndMultiShutdownAddData: {
                title: '定时关机',
                style: {
                    width: '480px',
                    height: '320px',
                    marginLeft: '-240px',
                    marginTop: '-160px'
                },
                type: 'wndMultiShutdownAdd',
                class: 'wndMultiShutdownAdd'
            },
            clockTimerArr: [],
            clockList: [],
            shutdownTimer: null
        }
    },
    components: {
        ModalSlot,
        ClockSetting,
        ShutdownSetting,
        BindPhone
    },
    mounted () {
        this.clientVersion =
            typeof window.clientInfo === 'string'
                ? JSON.parse(window.clientInfo).client_version
                : window.clientInfo
    },
    computed: {
        USER () {
            return store.state.USER
        },
        shutdownData () {
            return store.state.shutdownData
        },
        clockData () {
            return store.state.clockData
        }
    },
    watch: {
        USER: {
            deep: true,
            handler (n, o) {
                if (JSON.stringify(n) !== JSON.stringify(o) && n.box_token) {
                    this.getShutdownSetting()
                    this.checkClockSetting()
                }
            }
        },
        shutdownData: {
            deep: true,
            handler (n, o) {
                if (JSON.stringify(n) !== JSON.stringify(o)) {
                    clearInterval(this.shutdownTimer)
                    this.Storage.set('shutdownData', n, r => { })
                    this.shutdownRemind()
                }
            }
        },
        clockData: {
            deep: true,
            handler (n, o) {
                let t = this
                if (JSON.stringify(n) !== JSON.stringify(o)) {
                    this.clockList = n
                    if (this.clockTimerArr.length > 0) {
                        this.clockTimerArr.forEach((item, index) => {
                            clearInterval(item)
                        })
                    }
                    this.clockList.forEach((item, index) => {
                        t.addData(item)
                    })
                    this.clockTimerDown()
                }
            }
        }
    },
    beforeDestroy () {
        clearInterval(this.clockTimer)
        clearInterval(this.shutdownTimer)
    },
    methods: {
        // 按钮点击事件
        fnBtnClick (o) {
            let t = this
            if (typeof o === 'object') {
                if (o.dataType === 'modalSlotClose') {
                    switch (o.dataClose) {
                        case 'wndThirdLogin':
                            t.wndThirdLogin = false
                            t.wndLogin = true
                            break
                        case 'wndMultiAccount':
                            t.wndMultiAccount = false
                            break
                        case 'wndMultiAccountAdd':
                            t.wndMultiAccountAdd = false
                            break
                        case 'wndMultiAccountManage':
                            t.wndMultiAccountManage = false
                            break
                        case 'wndMultiClockAdd':
                            t.wndMultiClockAdd = false
                            break
                        case 'wndMultiShutdownAdd':
                            t.wndMultiShutdownAdd = false
                            break
                        case 'wndMultiPhone':
                            t.wndMultiPhone = false
                            break
                    }
                }
            } else {
                switch (o) {
                    case 'wndMultiAccount':
                        t.wndMultiAccount = true
                        t.wndMultiAccountAdd = false
                        t.wndMultiAccountManage = false
                        t.DSP.click({
                            type: 10,
                            pars: '',
                            url: '',
                            sourcename: '小号管理',
                            id: 2,
                            page_block_id: 8,
                            x_position: event.clientX,
                            y_position: event.clientY
                        })
                        break
                    case 'wndMultiAccountAdd':
                        t.wndMultiAccount = false
                        t.wndMultiAccountAdd = true
                        t.wndMultiAccountManage = false
                        t.DSP.click({
                            type: 10,
                            pars: '',
                            url: '',
                            sourcename: '添加小号',
                            id: 2001,
                            page_block_id: 8,
                            x_position: event.clientX,
                            y_position: event.clientY
                        })
                        break
                    case 'wndMultiAccountManage':
                        t.wndMultiAccount = false
                        t.wndMultiAccountAdd = false
                        t.wndMultiAccountManage = true
                        break
                }
            }
        },
        // 按钮点击事件
        fnPlayGame (o) {
            this.Storage.get('USER', res => {
                this.fnCefGameBox({
                    method: 'clientOpenWnd',
                    data: {
                        url: o.url,
                        type: o.coreType,
                        window_title:
                            o.gameName +
                            ' | ' +
                            o.serverName +
                            ' | ' +
                            o.passport || '易乐玩游戏盒子',
                        game_name: o.gameName,
                        game_code: o.gameCode,
                        server_name: o.serverName,
                        server_id: o.serverId,
                        passport: o.passport,
                        uid: o.uid
                    }
                })
            })
            this.DSP.click({
                type: 1,
                pars: o.gameCode + '_' + o.serverId,
                url: o.url,
                sourcename: o.gameName,
                id: o.serverId || 2004,
                page_block_id: 8,
                x_position: event.clientX,
                y_position: event.clientY
            })
        },
        // 绑定手机
        fnWndMultiPhone (dsp) {
            let t = this
            dsp &&
                t.DSP.click({
                    type: 10,
                    pars: '',
                    url: '',
                    sourcename: '绑定手机',
                    id: 2,
                    page_block_id: 8,
                    x_position: event.clientX,
                    y_position: event.clientY
                })
            t.Storage.get('USER', res => {
                if (res.status === 'error' || !res.data.USER) {
                    t.Toast({
                        content: '请先登录后再查看'
                    })
                    return
                }
                ELSDK.getUserInfo(r => {
                    if (r.data.bind_phone != null) {
                        t.Toast({
                            content: '您已绑定手机！'
                        })
                        return false
                    }
                    t.wndMultiPhone = true
                })
            })
        },
        // 小号管理面板添加小号按钮
        fnAddMultiAccount () {
            let t = this
            t.formMultiAccount = {
                passport: '',
                password: '',
                game_name: '',
                game_code: '',
                server_name: '',
                server_id: '',
                remark: '',
                verifyCode: '',
                verifyCodeImg: ''
            }
            t.wndMultiAccount = false
            t.wndMultiAccountManage = false
            t.wndMultiAccountAdd = true
            t.fnGetMultiGame()
            t.fnGetMultiVerifyCode()
            t.DSP.click({
                type: 10,
                pars: '',
                url: '',
                sourcename: '添加小号',
                id: 8002,
                page_block_id: 8,
                x_position: event.clientX,
                y_position: event.clientY
            })
        },
        // 拉取用户小号数据
        fnWndMultiAccount (dsp) {
            let t = this
            dsp &&
                t.DSP.click({
                    type: 10,
                    pars: '',
                    url: '',
                    sourcename: '小号管理',
                    id: 2,
                    page_block_id: 8,
                    x_position: event.clientX,
                    y_position: event.clientY
                })
            t.Storage.get('USER', res => {
                if (res.status === 'error' || !res.data.USER) {
                    t.Toast({
                        content: '请先登录后再查看'
                    })
                    return
                }
                t.XHR({
                    url: t.ports.user.slaveList,
                    cbFn (res) {
                        if (res.status === 'error') {
                            t.wndMultiAccount = !t.wndMultiAccount
                            return
                        }
                        if (res.data.length < 1) {
                            t.fnGetMultiGame()
                            t.wndMultiAccount = !t.wndMultiAccount
                            t.wndMultiAccountManage = false
                            t.fnGetMultiVerifyCode()
                        } else {
                            t.wndMultiAccount = false
                            t.wndMultiAccountAdd = false
                            t.wndMultiAccountListData = res.data
                            t.wndMultiAccountManage = true
                        }
                    }
                })
            })
        },
        // 编辑、删除小号
        fnChangeMultiAccount (type, id, idx) {
            let t = this
            if (type === 0) {
                if (t.wndMultiAccountAdd) return
                t.wndMultiAccountAdd = true
                t.fnGetMultiGame()
                t.formMultiAccount = {
                    passport: t.wndMultiAccountListData[idx].passport,
                    game_name: t.wndMultiAccountListData[idx].game_name,
                    game_code: t.wndMultiAccountListData[idx].game_code,
                    server_name: t.wndMultiAccountListData[idx].server_name,
                    server_id: t.wndMultiAccountListData[idx].server_id,
                    remark: t.wndMultiAccountListData[idx].remark
                }
                t.btnMultiAccountAddTxt = '保存'
                t.multiAccountGameId = id
                t.fnGetMultiVerifyCode()
                t.DSP.click({
                    type: 10,
                    pars: '',
                    url: '',
                    sourcename: '编辑小号-' + id,
                    id: 2002,
                    page_block_id: 8,
                    x_position: event.clientX,
                    y_position: event.clientY
                })
            } else {
                t.$confirm({
                    title: '你确定要删除吗?',
                    content: '',
                    centered: true,
                    cancelText: '取消',
                    okText: '确定',
                    onOk () {
                        t.XHR({
                            url: t.ports.user.slaveDelete,
                            data: {
                                id: id
                            },
                            cbFn (res) {
                                t.Toast({
                                    content: res.info
                                })
                                if (res.status === 'error') return
                                t.fnWndMultiAccount(false)
                            }
                        })
                    },
                    onCancel () {
                        window.console.log('Cancel')
                    },
                    class: 'test'
                })
                this.DSP.click({
                    type: 3,
                    pars: '',
                    url: '',
                    sourcename: '删除小号-' + id,
                    id: 2003,
                    page_block_id: 8,
                    x_position: event.clientX,
                    y_position: event.clientY
                })
            }
        },
        // 添加小号-游戏列表
        fnGetMultiGame () {
            let t = this
            if (t.multiGameList.length > 0) return
            let data = ''
            if (t.multiAccountGameId) {
                data = {
                    id: t.multiAccountGameId
                }
            }
            t.XHR({
                url: t.ports.user.slaveAllGame,
                data: data,
                cbFn (res) {
                    if (res.status === 'error') {
                        t.Toast({
                            content: res.info
                        })
                        return
                    }
                    t.multiGameList = res.data
                }
            })
        },
        // 添加小号-input框变化
        fnMultiInputChange (type, o) {
            if (type === 'allGame') {
                this.fnGetMultiGameServer(o.game_code)
                this.formMultiAccount.game_code = o.game_code
            } else {
                this.formMultiAccount.server_id = o.server_id
            }
        },
        // 添加小号-游戏区服列表
        fnGetMultiGameServer (id) {
            let t = this
            t.XHR({
                url: t.ports.user.slaveAllServer,
                data: {
                    game_code: id
                },
                cbFn (res) {
                    if (res.status === 'error') {
                        t.Toast({
                            content: res.info
                        })
                        return
                    }
                    t.formMultiAccount.server_id = ''
                    t.formMultiAccount.server_name = ''
                    if (res.data.length < 1) return
                    t.multiGameServerList = res.data
                    t.formMultiAccount.server_name =
                        t.multiGameServerList[0].server_name
                    t.formMultiAccount.server_id =
                        t.multiGameServerList[0].server_id
                }
            })
        },
        // 添加小号-input框获取焦点
        fnMultiInputFocus () { },
        // 添加小号-验证码
        fnGetMultiVerifyCode () {
            let t = this
            t.formMultiAccount.verifyCode = ''
            t.formMultiAccountverifyCodeImg = ''
            t.Storage.get('USER', res => {
                t.formMultiAccountverifyCodeImg =
                    t.ports.user.slaveCaptcha +
                    '?token=' +
                    res.data.USER.box_token +
                    '&ts=' +
                    Date.now()
            })
        },
        // 添加小号
        fnMultiAccountAdd () {
            let t = this
            t.Storage.get('USER', r => {
                if (!t.formMultiAccount.verifyCode) {
                    t.Toast({
                        content: '验证码不能为空'
                    })
                    return
                }
                let d = {
                    passport: t.formMultiAccount.passport,
                    password: t.formMultiAccount.password,
                    token: r.data.USER.box_token,
                    remark: t.formMultiAccount.remark,
                    captcha: t.formMultiAccount.verifyCode,
                    game_code: t.formMultiAccount.game_code,
                    server_id: t.formMultiAccount.server_id
                }
                if (t.multiAccountGameId) {
                    d.id = t.multiAccountGameId
                }
                if (t.btnFastClick) return
                t.btnFastClick = true
                t.XHR({
                    url: t.ports.user.slaveAdd,
                    method: 'POST',
                    data: d,
                    cbFn: res => {
                        t.btnFastClick = false
                        t.Toast({
                            content: res.info
                        })
                        if (res.status === 'success') {
                            t.fnWndMultiAccount(false)
                            t.formMultiAccountverifyCodeImg = ''
                            t.multiAccountGameId = ''
                        } else {
                            t.fnGetMultiVerifyCode()
                        }
                    }
                })
            })
        },
        fnRefreshCountDown () {
            let t = this
            let n = 60
            let nt = setInterval(() => {
                n--
                if (n < 1) {
                    n = 0
                    t.btnRefreshDataTxt = '刷新大厅游戏数据'
                    t.btnRefreshData = true
                    clearInterval(nt)
                    n = 60
                    return
                }
                t.btnRefreshDataTxt = n + ' 秒后可再次刷新游戏数据'
            }, 1000)
        },
        // 刷新数据
        fnRefreshData () {
            if (!this.btnRefreshData) return
            this.btnRefreshData = false
            this.$store.commit('FNSTATE', {
                reFreshPageData: this.$store.state.reFreshPageData + 1
            })
            this.fnRefreshCountDown()
            this.DSP.click({
                type: 12,
                pars: '',
                url: '',
                sourcename: '刷新游戏数据',
                id: 1,
                page_block_id: 8,
                x_position: event.clientX,
                y_position: event.clientY
            })
        },
        // 闹钟设置
        fnWndMultiClock (dsp) {
            let t = this
            dsp &&
                t.DSP.click({
                    type: 10,
                    pars: '',
                    url: '',
                    sourcename: '闹钟',
                    id: '',
                    page_block_id: 8,
                    x_position: event.clientX,
                    y_position: event.clientY
                })
            t.Storage.get('USER', res => {
                if (res.status === 'error' || !res.data.USER) {
                    t.Toast({
                        content: '请先登录后再查看'
                    })
                    return
                }
                t.wndMultiClockAdd = true
            })
        },
        // 检测闹钟设置
        checkClockSetting () {
            let t = this
            if (!t.USER.box_token) {
                t.$store.commit('FNSTATE', {
                    clockData: []
                })
                return false
            }
            t.XHR({
                url: t.ports.clock.check,
                data: {
                    token: t.USER.box_token
                },
                cbFn (res) {
                    if (res.status === 'error') {
                        return
                    }
                    if (res.data.list.length < 1) return
                    t.$store.commit('FNSTATE', {
                        clockData: res.data.list
                    })
                }
            })
        },
        clockTimerDown () {
            let t = this
            if (!t.USER.box_token) {
                return false
            }
            if (this.clockList.length > 0) {
                this.clockList.forEach((item, index) => {
                    this.countDown(item, index)
                })
            }
        },
        countDown (item, index) {
            this.clockTimerArr[index] = setInterval(() => {
                let timeNow = parseInt(new Date().getTime() / 1000)
                let currentTime = this.someDaySomeTime(item.hour, item.minute)
                if (!item.remind) {
                    currentTime = item.datetime
                }
                if (timeNow === currentTime) {
                    clearInterval(this.clockTimerArr[index])
                    this.CEF.API('clientOpenWnd', {
                        url: location.protocol + '//box.yilewan.com/#/ClockRemind?id=' + item.id,
                        status: 0,
                        type: 0,
                        width: window.screen.availWidth,
                        height: window.screen.availHeight,
                        center: false,
                        top: window.screen.availHeight - 260,
                        left: window.screen.availWidth - 420,
                        topmost: 0,
                        window_name: '闹钟提醒',
                        window_title: '闹钟提醒'
                    })
                }
            }, 1000)
        },
        async addData (data) {
            await this.db.clock.add(data).catch(err => { })
        },
        someDaySomeTime (hour, minute) {
            let today = new Date()
            // 将当天时间戳设为0点0分0秒
            today.setHours(0)
            today.setMinutes(0)
            today.setSeconds(0)
            today.setMilliseconds(0)
            // 计算一天的毫秒数
            // 获取指定天的时间戳   前面传负数
            let someDay = new Date(today.getTime())
            // 将指定天的时分秒设为我们指定的值
            someDay.setHours(Number(hour))
            someDay.setMinutes(Number(minute))
            today.setSeconds(0)
            someDay.setMilliseconds(0)
            return parseInt(someDay.getTime() / 1000)
        },
        // 关机设置
        fnWndMultiShutdown (dsp) {
            let t = this
            dsp &&
                t.DSP.click({
                    type: 10,
                    pars: '',
                    url: '',
                    sourcename: '关机',
                    id: '',
                    page_block_id: 8,
                    x_position: event.clientX,
                    y_position: event.clientY
                })
            t.Storage.get('USER', res => {
                if (res.status === 'error' || !res.data.USER) {
                    t.Toast({
                        content: '请先登录后再查看'
                    })
                    return
                }
                t.wndMultiShutdownAdd = true
            })
        },
        // 获取关机设置
        getShutdownSetting () {
            let t = this
            t.XHR({
                url: t.ports.shutdown.list,
                data: {
                    token: t.USER.box_token
                },
                cbFn (res) {
                    if (res.status === 'error') {
                        t.$store.commit('FNSTATE', {
                            shutdownData: {}
                        })
                        return
                    }
                    if (!res.data.info) {
                        t.$store.commit('FNSTATE', {
                            shutdownData: {}
                        })
                        return
                    }
                    t.$store.commit('FNSTATE', {
                        shutdownData: res.data.info
                    })
                }
            })
        },
        // 关机提醒
        shutdownRemind () {
            let t = this
            if (!t.shutdownData.id) {
                this.Storage.set('shutdownSecend', -1)
                clearTimeout(t.shutdownTimer)
                return
            }
            let timeNow = new Date().getTime()
            let timeEnd = t.shutdownData.datetime
            let timeRemind = (t.shutdownData.remind_before) * 60
            let timeDistance = (timeEnd - parseInt(timeNow / 1000))
            t.Storage.set('shutdownSecend', timeDistance)
            t.shutdownTimer = setTimeout(() => {
                t.shutdownRemind()
            }, 1000)
            if (timeDistance === timeRemind && t.shutdownData.remind_before > 0) {
                t.CEF.API('clientOpenWnd', {
                    url: location.protocol + '//box.yilewan.com/#/ShutdownRemind',
                    status: 0,
                    type: 0,
                    width: window.screen.availWidth,
                    height: window.screen.availHeight,
                    center: false,
                    top: window.screen.availHeight - 260,
                    left: window.screen.availWidth - 420,
                    topmost: 0,
                    window_name: '关机提醒',
                    window_title: '关机提醒'
                })
            } else if (timeDistance === 0) {
                clearTimeout(t.shutdownTimer)
                this.wndMultiShutdownAdd = false
                t.CEF.API('ShutdownOperation', res => {
                }, res => {
                })
            }
        }
    }
}
</script>

<style scoped>
</style>
